// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__7yG76","FooterLogo":"Footer_FooterLogo__34yl5","Icons":"Footer_Icons__2BEoi","row":"Footer_row__3sE6J","col-sm":"Footer_col-sm__3p_PF"};